import { useRouter } from "next/router";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import styles from "./index.module.scss";

export default function MarkSelector({ sectionPageUrl, onShow }: any) {
  const router = useRouter();
  const { params } = useSelector((state: any) => state.filter);
  const { marks, models, types } = useSelector((state: any) => state.models);
  const markKeys = Object.keys(marks).sort();

  const mobileSelectorText = useMemo(() => {
    if (params?.model) {
      return `${marks[params?.marka]?.NAME} ${models[params?.model]?.NAME}`;
    }
    if (params?.marka) {
      return marks[params?.marka]?.NAME;
    }
    return "Марка и модель";
  }, [params, marks]);

  return markKeys.length > 0 ? (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div
        className={styles.MobileSelector}
        onClick={() => {
          onShow();
        }}
      >
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 16 16"
            className="IconSvg IconSvg_name_SvgCarSOutline IconSvg_size_20"
          >
            <path
              fill="currentColor"
              fillRule="evenodd"
              d="M3.5 5.426c.36-.825.755-1.715 1.018-2.273.908-.18 2.177-.278 3.482-.278s2.574.097 3.482.278c.263.558.658 1.449 1.018 2.273.219.498.421.966.57 1.309l.006.015H2.924l.007-.015c.148-.343.35-.81.569-1.31ZM2.75 8.25v.535l2.397.48L5 10.75H2.75v1h10.5v-1H11l-.147-1.485 2.397-.48V8.25zm9.539 5.987-.33-.987H4.04l-.328.987-.171.513H1.25V7.374l-.487-.162L.25 7.04V5.25h1.69l.185-.426c.435-.993.944-2.138 1.204-2.66l.154-.308.335-.084C4.905 1.501 6.475 1.375 8 1.375s3.095.126 4.182.397l.335.084.154.309c.26.52.769 1.666 1.204 2.66l.185.425h1.69v1.79l-.513.172-.487.162v7.376h-2.29z"
            />
          </svg>
          <div className={styles.MobileSelectorInfo}>
            <div className={styles.MarkModel}>{mobileSelectorText}</div>
            <div className={styles.Kuzov}>
              {params?.kuzov ? types[params?.kuzov]?.NAME : "Все поколения"}
            </div>
          </div>
        </div>
        {params?.kuzov ? (
          <>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
              className={styles.MobileSelectorReset}
              onClick={async (e) => {
                e.stopPropagation();
                await router.push(sectionPageUrl);
                onShow();
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#384250"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </>
        ) : (
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
              className="IconSvg IconSvg_name_SvgChevronRightM IconSvg_size_24"
            >
              <path
                fill="currentColor"
                d="m16.5 12-7 7-1.461-1.379L13.659 12 8.04 6.379 9.499 5z"
              />
            </svg>
          </div>
        )}
      </div>
    </>
  ) : null;
}
